/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Qwick Core API
 * AKA V3, AKA Gigpro, AKA sidegig-api
 * OpenAPI spec version: 0.0.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AddRequirementToAccount,
  AddRequirementToAccountRequest,
  BaseCertificationRequest,
  BaseCertificationRequestRequest,
  CertGapsResponse,
  Employee,
  EmployeeEarningsStats,
  ExpiringCertification,
  GigHistorySkill,
  GigsterProfile,
  GigsterProfileReadonly,
  GigsterProfileRequest,
  GigsterProfilesAvailableCertificationsListParams,
  GigsterProfilesCertGapsRetrieveParams,
  GigsterProfilesCertificationRequestsListParams,
  GigsterProfilesReviewStatsRetrieveParams,
  GigsterProfilesStripeAccountLinkRetrieveParams,
  GigsterProfilesStripeAccountStatusRetrieveParams,
  GigsterProfilesWorkHistoryListParams,
  GigsterProfilesWorkHistoryRecordsListParams,
  OnboardingStepStatus,
  PaginatedBaseCertificationRequestList,
  PaginatedProAvailableCertificationList,
  PatchedGigsterProfileRequest,
  PatchedProCertificationRequestUpdateRequest,
  ReviewStats,
  ServiceUnavailableError,
  StripeAccountLink,
  StripeAccountStatus,
  StripeLoginLink,
  WorkHistoryRecord
} from '../model';

import { customFetch } from '../../custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGigsterProfilesListUrl = () => {




  return `/api/gigster-profiles/`
}

export const gigsterProfilesList = async ( options?: Parameters<typeof customFetch>[1]): Promise<unknown> => {

  return customFetch<unknown>(getGigsterProfilesListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGigsterProfilesListQueryKey = () => {
    return [
    `/api/gigster-profiles/`
    ] as const;
    }


export const getGigsterProfilesListQueryOptions = <TData = Awaited<ReturnType<typeof gigsterProfilesList>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGigsterProfilesListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof gigsterProfilesList>>> = ({ signal }) => gigsterProfilesList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GigsterProfilesListQueryResult = NonNullable<Awaited<ReturnType<typeof gigsterProfilesList>>>
export type GigsterProfilesListQueryError = void


export function useGigsterProfilesList<TData = Awaited<ReturnType<typeof gigsterProfilesList>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsterProfilesList>>,
          TError,
          Awaited<ReturnType<typeof gigsterProfilesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsterProfilesList<TData = Awaited<ReturnType<typeof gigsterProfilesList>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsterProfilesList>>,
          TError,
          Awaited<ReturnType<typeof gigsterProfilesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsterProfilesList<TData = Awaited<ReturnType<typeof gigsterProfilesList>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGigsterProfilesList<TData = Awaited<ReturnType<typeof gigsterProfilesList>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGigsterProfilesListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGigsterProfilesCreateUrl = () => {




  return `/api/gigster-profiles/`
}

export const gigsterProfilesCreate = async (gigsterProfileRequest?: GigsterProfileRequest, options?: Parameters<typeof customFetch>[1]): Promise<void | GigsterProfile> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<void | GigsterProfile>(getGigsterProfilesCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(gigsterProfileRequest)
  }
);}





export const getGigsterProfilesCreateMutationKey = () => ['gigsterProfilesCreate'] as const;

export const getGigsterProfilesCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof gigsterProfilesCreate>>, TError,GigsterProfilesCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof gigsterProfilesCreate>>, TError,GigsterProfilesCreateMutationVariables, TContext> => {

const mutationKey = getGigsterProfilesCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof gigsterProfilesCreate>>, GigsterProfilesCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  gigsterProfilesCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GigsterProfilesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof gigsterProfilesCreate>>>
    export type GigsterProfilesCreateMutationBody = GigsterProfileRequest | undefined
    export type GigsterProfilesCreateMutationError = void
    export type GigsterProfilesCreateMutationVariables = {data?: GigsterProfileRequest}

    export const useGigsterProfilesCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof gigsterProfilesCreate>>, TError,GigsterProfilesCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof gigsterProfilesCreate>>,
        TError,
        GigsterProfilesCreateMutationVariables,
        TContext
      > => {
      return useMutation(getGigsterProfilesCreateMutationOptions(options), queryClient);
    }
    export const getGigsterProfilesWorkHistoryRecordsListUrl = (id: number,
    params?: GigsterProfilesWorkHistoryRecordsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/gigster-profiles/${id}/work-history-records/?${stringifiedParams}` : `/api/gigster-profiles/${id}/work-history-records/`
}

/**
 * This viewset will only provide listing/readonly behavior.
 * I've introduced this new view instead of update the one below for two main reasons:
 * - Primary intention of WorkHistoryRecordsView is to be used by Pros, they can add, edit,
 * list, retrieve and delete their work history information. Other roles can only read, I can add if conditions
 * to the get_queryset but it could have an unnecessary mix of conditions which will have unexpected behavior
 * if a user has more than one role. Also the queryset is used for operations like edit, remove, retrieve and list
 * and the conditions will also affect that existing behavior.
 * - I want to have an intuitive way to get data from a Pro Profile so I would like to have an endpoint
 * /gigster-profiles/PRO_ID/work-history-records to get the work history records of a Pro as a non Pro
 * user. To get the same behavior updating the existing view can imply using tricky ways to accomplish the
 * new endpoint.
 */
export const gigsterProfilesWorkHistoryRecordsList = async (id: number,
    params?: GigsterProfilesWorkHistoryRecordsListParams, options?: Parameters<typeof customFetch>[1]): Promise<WorkHistoryRecord[]> => {

  return customFetch<WorkHistoryRecord[]>(getGigsterProfilesWorkHistoryRecordsListUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGigsterProfilesWorkHistoryRecordsListQueryKey = (id: number,
    params?: GigsterProfilesWorkHistoryRecordsListParams,) => {
    return [
    `/api/gigster-profiles/${id}/work-history-records/`, ...(params ? [params] : [])
    ] as const;
    }


export const getGigsterProfilesWorkHistoryRecordsListQueryOptions = <TData = Awaited<ReturnType<typeof gigsterProfilesWorkHistoryRecordsList>>, TError = void>(id: number,
    params?: GigsterProfilesWorkHistoryRecordsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesWorkHistoryRecordsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGigsterProfilesWorkHistoryRecordsListQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof gigsterProfilesWorkHistoryRecordsList>>> = ({ signal }) => gigsterProfilesWorkHistoryRecordsList(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesWorkHistoryRecordsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GigsterProfilesWorkHistoryRecordsListQueryResult = NonNullable<Awaited<ReturnType<typeof gigsterProfilesWorkHistoryRecordsList>>>
export type GigsterProfilesWorkHistoryRecordsListQueryError = void


export function useGigsterProfilesWorkHistoryRecordsList<TData = Awaited<ReturnType<typeof gigsterProfilesWorkHistoryRecordsList>>, TError = void>(
 id: number,
    params: undefined |  GigsterProfilesWorkHistoryRecordsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesWorkHistoryRecordsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsterProfilesWorkHistoryRecordsList>>,
          TError,
          Awaited<ReturnType<typeof gigsterProfilesWorkHistoryRecordsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsterProfilesWorkHistoryRecordsList<TData = Awaited<ReturnType<typeof gigsterProfilesWorkHistoryRecordsList>>, TError = void>(
 id: number,
    params?: GigsterProfilesWorkHistoryRecordsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesWorkHistoryRecordsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsterProfilesWorkHistoryRecordsList>>,
          TError,
          Awaited<ReturnType<typeof gigsterProfilesWorkHistoryRecordsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsterProfilesWorkHistoryRecordsList<TData = Awaited<ReturnType<typeof gigsterProfilesWorkHistoryRecordsList>>, TError = void>(
 id: number,
    params?: GigsterProfilesWorkHistoryRecordsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesWorkHistoryRecordsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGigsterProfilesWorkHistoryRecordsList<TData = Awaited<ReturnType<typeof gigsterProfilesWorkHistoryRecordsList>>, TError = void>(
 id: number,
    params?: GigsterProfilesWorkHistoryRecordsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesWorkHistoryRecordsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGigsterProfilesWorkHistoryRecordsListQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGigsterProfilesRetrieveUrl = (id: number | 'me',) => {




  return `/api/gigster-profiles/${id}/`
}

export const gigsterProfilesRetrieve = async (id: number | 'me', options?: Parameters<typeof customFetch>[1]): Promise<GigsterProfileReadonly> => {

  return customFetch<GigsterProfileReadonly>(getGigsterProfilesRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGigsterProfilesRetrieveQueryKey = (id: number | 'me',) => {
    return [
    `/api/gigster-profiles/${id}/`
    ] as const;
    }


export const getGigsterProfilesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof gigsterProfilesRetrieve>>, TError = void>(id: number | 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGigsterProfilesRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof gigsterProfilesRetrieve>>> = ({ signal }) => gigsterProfilesRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GigsterProfilesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof gigsterProfilesRetrieve>>>
export type GigsterProfilesRetrieveQueryError = void


export function useGigsterProfilesRetrieve<TData = Awaited<ReturnType<typeof gigsterProfilesRetrieve>>, TError = void>(
 id: number | 'me', options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsterProfilesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof gigsterProfilesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsterProfilesRetrieve<TData = Awaited<ReturnType<typeof gigsterProfilesRetrieve>>, TError = void>(
 id: number | 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsterProfilesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof gigsterProfilesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsterProfilesRetrieve<TData = Awaited<ReturnType<typeof gigsterProfilesRetrieve>>, TError = void>(
 id: number | 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGigsterProfilesRetrieve<TData = Awaited<ReturnType<typeof gigsterProfilesRetrieve>>, TError = void>(
 id: number | 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGigsterProfilesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGigsterProfilesUpdateUrl = (id: number | 'me',) => {




  return `/api/gigster-profiles/${id}/`
}

export const gigsterProfilesUpdate = async (id: number | 'me',
    gigsterProfileRequest?: GigsterProfileRequest, options?: Parameters<typeof customFetch>[1]): Promise<GigsterProfile> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<GigsterProfile>(getGigsterProfilesUpdateUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(gigsterProfileRequest)
  }
);}





export const getGigsterProfilesUpdateMutationKey = () => ['gigsterProfilesUpdate'] as const;

export const getGigsterProfilesUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof gigsterProfilesUpdate>>, TError,GigsterProfilesUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof gigsterProfilesUpdate>>, TError,GigsterProfilesUpdateMutationVariables, TContext> => {

const mutationKey = getGigsterProfilesUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof gigsterProfilesUpdate>>, GigsterProfilesUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  gigsterProfilesUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GigsterProfilesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof gigsterProfilesUpdate>>>
    export type GigsterProfilesUpdateMutationBody = GigsterProfileRequest | undefined
    export type GigsterProfilesUpdateMutationError = void
    export type GigsterProfilesUpdateMutationVariables = {id: number | 'me';data?: GigsterProfileRequest}

    export const useGigsterProfilesUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof gigsterProfilesUpdate>>, TError,GigsterProfilesUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof gigsterProfilesUpdate>>,
        TError,
        GigsterProfilesUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getGigsterProfilesUpdateMutationOptions(options), queryClient);
    }
    export const getGigsterProfilesPartialUpdateUrl = (id: number | 'me',) => {




  return `/api/gigster-profiles/${id}/`
}

export const gigsterProfilesPartialUpdate = async (id: number | 'me',
    patchedGigsterProfileRequest?: PatchedGigsterProfileRequest, options?: Parameters<typeof customFetch>[1]): Promise<GigsterProfile> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<GigsterProfile>(getGigsterProfilesPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedGigsterProfileRequest)
  }
);}





export const getGigsterProfilesPartialUpdateMutationKey = () => ['gigsterProfilesPartialUpdate'] as const;

export const getGigsterProfilesPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof gigsterProfilesPartialUpdate>>, TError,GigsterProfilesPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof gigsterProfilesPartialUpdate>>, TError,GigsterProfilesPartialUpdateMutationVariables, TContext> => {

const mutationKey = getGigsterProfilesPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof gigsterProfilesPartialUpdate>>, GigsterProfilesPartialUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  gigsterProfilesPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GigsterProfilesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof gigsterProfilesPartialUpdate>>>
    export type GigsterProfilesPartialUpdateMutationBody = PatchedGigsterProfileRequest | undefined
    export type GigsterProfilesPartialUpdateMutationError = void
    export type GigsterProfilesPartialUpdateMutationVariables = {id: number | 'me';data?: PatchedGigsterProfileRequest}

    export const useGigsterProfilesPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof gigsterProfilesPartialUpdate>>, TError,GigsterProfilesPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof gigsterProfilesPartialUpdate>>,
        TError,
        GigsterProfilesPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getGigsterProfilesPartialUpdateMutationOptions(options), queryClient);
    }
    export const getGigsterProfilesAvailableCertificationsListUrl = (id: number | 'me',
    params?: GigsterProfilesAvailableCertificationsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/gigster-profiles/${id}/available-certifications/?${stringifiedParams}` : `/api/gigster-profiles/${id}/available-certifications/`
}

/**
 * List visible certs, resolving each ``instructional_url`` to the Pro's
 * home-market link (CORE-6339).
 *
 * The home-market link map is built from ONE bulk query scoped to the
 * page's cert ids AND the Pro's home market
 * (``build_cert_market_link_index(cert_ids, market_ids={home_market_id})``),
 * then injected into the serializer context so
 * ``ProAvailableCertificationSerializer`` resolves each row in-memory — no
 * N+1. Budget: +1 query over the base list (skipped entirely when the Pro
 * has no home market, since only universal certs are visible then).
 */
export const gigsterProfilesAvailableCertificationsList = async (id: number | 'me',
    params?: GigsterProfilesAvailableCertificationsListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedProAvailableCertificationList> => {

  return customFetch<PaginatedProAvailableCertificationList>(getGigsterProfilesAvailableCertificationsListUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGigsterProfilesAvailableCertificationsListInfiniteQueryKey = (id: number | 'me',
    params?: GigsterProfilesAvailableCertificationsListParams,) => {
    return [
    'infinite', `/api/gigster-profiles/${id}/available-certifications/`, ...(params ? [params] : [])
    ] as const;
    }

export const getGigsterProfilesAvailableCertificationsListQueryKey = (id: number | 'me',
    params?: GigsterProfilesAvailableCertificationsListParams,) => {
    return [
    `/api/gigster-profiles/${id}/available-certifications/`, ...(params ? [params] : [])
    ] as const;
    }


export const getGigsterProfilesAvailableCertificationsListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof gigsterProfilesAvailableCertificationsList>>, GigsterProfilesAvailableCertificationsListParams['page']>, TError = void>(id: number | 'me',
    params?: GigsterProfilesAvailableCertificationsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof gigsterProfilesAvailableCertificationsList>>, TError, TData, QueryKey, GigsterProfilesAvailableCertificationsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGigsterProfilesAvailableCertificationsListInfiniteQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof gigsterProfilesAvailableCertificationsList>>, QueryKey, GigsterProfilesAvailableCertificationsListParams['page']> = ({ signal, pageParam }) => gigsterProfilesAvailableCertificationsList(id,{...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof gigsterProfilesAvailableCertificationsList>>, TError, TData, QueryKey, GigsterProfilesAvailableCertificationsListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GigsterProfilesAvailableCertificationsListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof gigsterProfilesAvailableCertificationsList>>>
export type GigsterProfilesAvailableCertificationsListInfiniteQueryError = void


export function useGigsterProfilesAvailableCertificationsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof gigsterProfilesAvailableCertificationsList>>, GigsterProfilesAvailableCertificationsListParams['page']>, TError = void>(
 id: number | 'me',
    params: undefined |  GigsterProfilesAvailableCertificationsListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof gigsterProfilesAvailableCertificationsList>>, TError, TData, QueryKey, GigsterProfilesAvailableCertificationsListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsterProfilesAvailableCertificationsList>>,
          TError,
          Awaited<ReturnType<typeof gigsterProfilesAvailableCertificationsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsterProfilesAvailableCertificationsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof gigsterProfilesAvailableCertificationsList>>, GigsterProfilesAvailableCertificationsListParams['page']>, TError = void>(
 id: number | 'me',
    params?: GigsterProfilesAvailableCertificationsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof gigsterProfilesAvailableCertificationsList>>, TError, TData, QueryKey, GigsterProfilesAvailableCertificationsListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsterProfilesAvailableCertificationsList>>,
          TError,
          Awaited<ReturnType<typeof gigsterProfilesAvailableCertificationsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsterProfilesAvailableCertificationsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof gigsterProfilesAvailableCertificationsList>>, GigsterProfilesAvailableCertificationsListParams['page']>, TError = void>(
 id: number | 'me',
    params?: GigsterProfilesAvailableCertificationsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof gigsterProfilesAvailableCertificationsList>>, TError, TData, QueryKey, GigsterProfilesAvailableCertificationsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGigsterProfilesAvailableCertificationsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof gigsterProfilesAvailableCertificationsList>>, GigsterProfilesAvailableCertificationsListParams['page']>, TError = void>(
 id: number | 'me',
    params?: GigsterProfilesAvailableCertificationsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof gigsterProfilesAvailableCertificationsList>>, TError, TData, QueryKey, GigsterProfilesAvailableCertificationsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGigsterProfilesAvailableCertificationsListInfiniteQueryOptions(id,params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGigsterProfilesAvailableCertificationsListQueryOptions = <TData = Awaited<ReturnType<typeof gigsterProfilesAvailableCertificationsList>>, TError = void>(id: number | 'me',
    params?: GigsterProfilesAvailableCertificationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesAvailableCertificationsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGigsterProfilesAvailableCertificationsListQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof gigsterProfilesAvailableCertificationsList>>> = ({ signal }) => gigsterProfilesAvailableCertificationsList(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesAvailableCertificationsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GigsterProfilesAvailableCertificationsListQueryResult = NonNullable<Awaited<ReturnType<typeof gigsterProfilesAvailableCertificationsList>>>
export type GigsterProfilesAvailableCertificationsListQueryError = void


export function useGigsterProfilesAvailableCertificationsList<TData = Awaited<ReturnType<typeof gigsterProfilesAvailableCertificationsList>>, TError = void>(
 id: number | 'me',
    params: undefined |  GigsterProfilesAvailableCertificationsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesAvailableCertificationsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsterProfilesAvailableCertificationsList>>,
          TError,
          Awaited<ReturnType<typeof gigsterProfilesAvailableCertificationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsterProfilesAvailableCertificationsList<TData = Awaited<ReturnType<typeof gigsterProfilesAvailableCertificationsList>>, TError = void>(
 id: number | 'me',
    params?: GigsterProfilesAvailableCertificationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesAvailableCertificationsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsterProfilesAvailableCertificationsList>>,
          TError,
          Awaited<ReturnType<typeof gigsterProfilesAvailableCertificationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsterProfilesAvailableCertificationsList<TData = Awaited<ReturnType<typeof gigsterProfilesAvailableCertificationsList>>, TError = void>(
 id: number | 'me',
    params?: GigsterProfilesAvailableCertificationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesAvailableCertificationsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGigsterProfilesAvailableCertificationsList<TData = Awaited<ReturnType<typeof gigsterProfilesAvailableCertificationsList>>, TError = void>(
 id: number | 'me',
    params?: GigsterProfilesAvailableCertificationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesAvailableCertificationsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGigsterProfilesAvailableCertificationsListQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGigsterProfilesCertGapsRetrieveUrl = (id: number | 'me',
    params?: GigsterProfilesCertGapsRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/gigster-profiles/${id}/cert-gaps/?${stringifiedParams}` : `/api/gigster-profiles/${id}/cert-gaps/`
}

/**
 * Return the cert-gaps payload for ``request.user``.
 *
 * Thin view — resolve the user id, parse the query string, delegate to
 * the service, return.
 */
export const gigsterProfilesCertGapsRetrieve = async (id: number | 'me',
    params?: GigsterProfilesCertGapsRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<CertGapsResponse> => {

  return customFetch<CertGapsResponse>(getGigsterProfilesCertGapsRetrieveUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGigsterProfilesCertGapsRetrieveQueryKey = (id: number | 'me',
    params?: GigsterProfilesCertGapsRetrieveParams,) => {
    return [
    `/api/gigster-profiles/${id}/cert-gaps/`, ...(params ? [params] : [])
    ] as const;
    }


export const getGigsterProfilesCertGapsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof gigsterProfilesCertGapsRetrieve>>, TError = void>(id: number | 'me',
    params?: GigsterProfilesCertGapsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesCertGapsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGigsterProfilesCertGapsRetrieveQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof gigsterProfilesCertGapsRetrieve>>> = ({ signal }) => gigsterProfilesCertGapsRetrieve(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesCertGapsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GigsterProfilesCertGapsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof gigsterProfilesCertGapsRetrieve>>>
export type GigsterProfilesCertGapsRetrieveQueryError = void


export function useGigsterProfilesCertGapsRetrieve<TData = Awaited<ReturnType<typeof gigsterProfilesCertGapsRetrieve>>, TError = void>(
 id: number | 'me',
    params: undefined |  GigsterProfilesCertGapsRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesCertGapsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsterProfilesCertGapsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof gigsterProfilesCertGapsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsterProfilesCertGapsRetrieve<TData = Awaited<ReturnType<typeof gigsterProfilesCertGapsRetrieve>>, TError = void>(
 id: number | 'me',
    params?: GigsterProfilesCertGapsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesCertGapsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsterProfilesCertGapsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof gigsterProfilesCertGapsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsterProfilesCertGapsRetrieve<TData = Awaited<ReturnType<typeof gigsterProfilesCertGapsRetrieve>>, TError = void>(
 id: number | 'me',
    params?: GigsterProfilesCertGapsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesCertGapsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGigsterProfilesCertGapsRetrieve<TData = Awaited<ReturnType<typeof gigsterProfilesCertGapsRetrieve>>, TError = void>(
 id: number | 'me',
    params?: GigsterProfilesCertGapsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesCertGapsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGigsterProfilesCertGapsRetrieveQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGigsterProfilesCertiflyAccountCreateUrl = (id: number | 'me',) => {




  return `/api/gigster-profiles/${id}/certifly-account/`
}

/**
 * Enqueue Certifly provisioning for the authenticated Pro and 202.
 */
export const gigsterProfilesCertiflyAccountCreate = async (id: number | 'me', options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getGigsterProfilesCertiflyAccountCreateUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getGigsterProfilesCertiflyAccountCreateMutationKey = () => ['gigsterProfilesCertiflyAccountCreate'] as const;

export const getGigsterProfilesCertiflyAccountCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof gigsterProfilesCertiflyAccountCreate>>, TError,GigsterProfilesCertiflyAccountCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof gigsterProfilesCertiflyAccountCreate>>, TError,GigsterProfilesCertiflyAccountCreateMutationVariables, TContext> => {

const mutationKey = getGigsterProfilesCertiflyAccountCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof gigsterProfilesCertiflyAccountCreate>>, GigsterProfilesCertiflyAccountCreateMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  gigsterProfilesCertiflyAccountCreate(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GigsterProfilesCertiflyAccountCreateMutationResult = NonNullable<Awaited<ReturnType<typeof gigsterProfilesCertiflyAccountCreate>>>

    export type GigsterProfilesCertiflyAccountCreateMutationError = void
    export type GigsterProfilesCertiflyAccountCreateMutationVariables = {id: number | 'me'}

    export const useGigsterProfilesCertiflyAccountCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof gigsterProfilesCertiflyAccountCreate>>, TError,GigsterProfilesCertiflyAccountCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof gigsterProfilesCertiflyAccountCreate>>,
        TError,
        GigsterProfilesCertiflyAccountCreateMutationVariables,
        TContext
      > => {
      return useMutation(getGigsterProfilesCertiflyAccountCreateMutationOptions(options), queryClient);
    }
    export const getGigsterProfilesExpiringCertificationsListUrl = (id: number | 'me',) => {




  return `/api/gigster-profiles/${id}/expiring-certifications/`
}

/**
 * The requesting Pro's APPROVED, expirable-type certs due within 10 days.
 * Only 'me' (or the caller's own id) is supported.
 */
export const gigsterProfilesExpiringCertificationsList = async (id: number | 'me', options?: Parameters<typeof customFetch>[1]): Promise<ExpiringCertification[]> => {

  return customFetch<ExpiringCertification[]>(getGigsterProfilesExpiringCertificationsListUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGigsterProfilesExpiringCertificationsListQueryKey = (id: number | 'me',) => {
    return [
    `/api/gigster-profiles/${id}/expiring-certifications/`
    ] as const;
    }


export const getGigsterProfilesExpiringCertificationsListQueryOptions = <TData = Awaited<ReturnType<typeof gigsterProfilesExpiringCertificationsList>>, TError = void>(id: number | 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesExpiringCertificationsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGigsterProfilesExpiringCertificationsListQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof gigsterProfilesExpiringCertificationsList>>> = ({ signal }) => gigsterProfilesExpiringCertificationsList(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesExpiringCertificationsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GigsterProfilesExpiringCertificationsListQueryResult = NonNullable<Awaited<ReturnType<typeof gigsterProfilesExpiringCertificationsList>>>
export type GigsterProfilesExpiringCertificationsListQueryError = void


export function useGigsterProfilesExpiringCertificationsList<TData = Awaited<ReturnType<typeof gigsterProfilesExpiringCertificationsList>>, TError = void>(
 id: number | 'me', options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesExpiringCertificationsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsterProfilesExpiringCertificationsList>>,
          TError,
          Awaited<ReturnType<typeof gigsterProfilesExpiringCertificationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsterProfilesExpiringCertificationsList<TData = Awaited<ReturnType<typeof gigsterProfilesExpiringCertificationsList>>, TError = void>(
 id: number | 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesExpiringCertificationsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsterProfilesExpiringCertificationsList>>,
          TError,
          Awaited<ReturnType<typeof gigsterProfilesExpiringCertificationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsterProfilesExpiringCertificationsList<TData = Awaited<ReturnType<typeof gigsterProfilesExpiringCertificationsList>>, TError = void>(
 id: number | 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesExpiringCertificationsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGigsterProfilesExpiringCertificationsList<TData = Awaited<ReturnType<typeof gigsterProfilesExpiringCertificationsList>>, TError = void>(
 id: number | 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesExpiringCertificationsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGigsterProfilesExpiringCertificationsListQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGigsterProfilesGigStatsSkillsListUrl = (id: number | 'me',) => {




  return `/api/gigster-profiles/${id}/gig-stats/skills/`
}

/**
 * Gig history is readonly data about the work history in Gigpro. Use /me/ to
 * reference current pro's gig history.
 */
export const gigsterProfilesGigStatsSkillsList = async (id: number | 'me', options?: Parameters<typeof customFetch>[1]): Promise<GigHistorySkill[]> => {

  return customFetch<GigHistorySkill[]>(getGigsterProfilesGigStatsSkillsListUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGigsterProfilesGigStatsSkillsListQueryKey = (id: number | 'me',) => {
    return [
    `/api/gigster-profiles/${id}/gig-stats/skills/`
    ] as const;
    }


export const getGigsterProfilesGigStatsSkillsListQueryOptions = <TData = Awaited<ReturnType<typeof gigsterProfilesGigStatsSkillsList>>, TError = void>(id: number | 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesGigStatsSkillsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGigsterProfilesGigStatsSkillsListQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof gigsterProfilesGigStatsSkillsList>>> = ({ signal }) => gigsterProfilesGigStatsSkillsList(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesGigStatsSkillsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GigsterProfilesGigStatsSkillsListQueryResult = NonNullable<Awaited<ReturnType<typeof gigsterProfilesGigStatsSkillsList>>>
export type GigsterProfilesGigStatsSkillsListQueryError = void


export function useGigsterProfilesGigStatsSkillsList<TData = Awaited<ReturnType<typeof gigsterProfilesGigStatsSkillsList>>, TError = void>(
 id: number | 'me', options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesGigStatsSkillsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsterProfilesGigStatsSkillsList>>,
          TError,
          Awaited<ReturnType<typeof gigsterProfilesGigStatsSkillsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsterProfilesGigStatsSkillsList<TData = Awaited<ReturnType<typeof gigsterProfilesGigStatsSkillsList>>, TError = void>(
 id: number | 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesGigStatsSkillsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsterProfilesGigStatsSkillsList>>,
          TError,
          Awaited<ReturnType<typeof gigsterProfilesGigStatsSkillsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsterProfilesGigStatsSkillsList<TData = Awaited<ReturnType<typeof gigsterProfilesGigStatsSkillsList>>, TError = void>(
 id: number | 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesGigStatsSkillsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGigsterProfilesGigStatsSkillsList<TData = Awaited<ReturnType<typeof gigsterProfilesGigStatsSkillsList>>, TError = void>(
 id: number | 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesGigStatsSkillsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGigsterProfilesGigStatsSkillsListQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGigsterProfilesOnboardingStepsListUrl = (id: number | 'me',) => {




  return `/api/gigster-profiles/${id}/onboarding-steps/`
}

export const gigsterProfilesOnboardingStepsList = async (id: number | 'me', options?: Parameters<typeof customFetch>[1]): Promise<OnboardingStepStatus[]> => {

  return customFetch<OnboardingStepStatus[]>(getGigsterProfilesOnboardingStepsListUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGigsterProfilesOnboardingStepsListQueryKey = (id: number | 'me',) => {
    return [
    `/api/gigster-profiles/${id}/onboarding-steps/`
    ] as const;
    }


export const getGigsterProfilesOnboardingStepsListQueryOptions = <TData = Awaited<ReturnType<typeof gigsterProfilesOnboardingStepsList>>, TError = void>(id: number | 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesOnboardingStepsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGigsterProfilesOnboardingStepsListQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof gigsterProfilesOnboardingStepsList>>> = ({ signal }) => gigsterProfilesOnboardingStepsList(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesOnboardingStepsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GigsterProfilesOnboardingStepsListQueryResult = NonNullable<Awaited<ReturnType<typeof gigsterProfilesOnboardingStepsList>>>
export type GigsterProfilesOnboardingStepsListQueryError = void


export function useGigsterProfilesOnboardingStepsList<TData = Awaited<ReturnType<typeof gigsterProfilesOnboardingStepsList>>, TError = void>(
 id: number | 'me', options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesOnboardingStepsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsterProfilesOnboardingStepsList>>,
          TError,
          Awaited<ReturnType<typeof gigsterProfilesOnboardingStepsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsterProfilesOnboardingStepsList<TData = Awaited<ReturnType<typeof gigsterProfilesOnboardingStepsList>>, TError = void>(
 id: number | 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesOnboardingStepsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsterProfilesOnboardingStepsList>>,
          TError,
          Awaited<ReturnType<typeof gigsterProfilesOnboardingStepsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsterProfilesOnboardingStepsList<TData = Awaited<ReturnType<typeof gigsterProfilesOnboardingStepsList>>, TError = void>(
 id: number | 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesOnboardingStepsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGigsterProfilesOnboardingStepsList<TData = Awaited<ReturnType<typeof gigsterProfilesOnboardingStepsList>>, TError = void>(
 id: number | 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesOnboardingStepsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGigsterProfilesOnboardingStepsListQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGigsterProfilesReviewStatsRetrieveUrl = (id: number | 'me',
    params?: GigsterProfilesReviewStatsRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/gigster-profiles/${id}/review-stats/?${stringifiedParams}` : `/api/gigster-profiles/${id}/review-stats/`
}

/**
 * Gig history is readonly data about the work history in Gigpro. Use /me/ to
 * reference current pro's gig history.
 */
export const gigsterProfilesReviewStatsRetrieve = async (id: number | 'me',
    params?: GigsterProfilesReviewStatsRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<ReviewStats> => {

  return customFetch<ReviewStats>(getGigsterProfilesReviewStatsRetrieveUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGigsterProfilesReviewStatsRetrieveQueryKey = (id: number | 'me',
    params?: GigsterProfilesReviewStatsRetrieveParams,) => {
    return [
    `/api/gigster-profiles/${id}/review-stats/`, ...(params ? [params] : [])
    ] as const;
    }


export const getGigsterProfilesReviewStatsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof gigsterProfilesReviewStatsRetrieve>>, TError = void>(id: number | 'me',
    params?: GigsterProfilesReviewStatsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesReviewStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGigsterProfilesReviewStatsRetrieveQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof gigsterProfilesReviewStatsRetrieve>>> = ({ signal }) => gigsterProfilesReviewStatsRetrieve(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesReviewStatsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GigsterProfilesReviewStatsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof gigsterProfilesReviewStatsRetrieve>>>
export type GigsterProfilesReviewStatsRetrieveQueryError = void


export function useGigsterProfilesReviewStatsRetrieve<TData = Awaited<ReturnType<typeof gigsterProfilesReviewStatsRetrieve>>, TError = void>(
 id: number | 'me',
    params: undefined |  GigsterProfilesReviewStatsRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesReviewStatsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsterProfilesReviewStatsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof gigsterProfilesReviewStatsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsterProfilesReviewStatsRetrieve<TData = Awaited<ReturnType<typeof gigsterProfilesReviewStatsRetrieve>>, TError = void>(
 id: number | 'me',
    params?: GigsterProfilesReviewStatsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesReviewStatsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsterProfilesReviewStatsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof gigsterProfilesReviewStatsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsterProfilesReviewStatsRetrieve<TData = Awaited<ReturnType<typeof gigsterProfilesReviewStatsRetrieve>>, TError = void>(
 id: number | 'me',
    params?: GigsterProfilesReviewStatsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesReviewStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGigsterProfilesReviewStatsRetrieve<TData = Awaited<ReturnType<typeof gigsterProfilesReviewStatsRetrieve>>, TError = void>(
 id: number | 'me',
    params?: GigsterProfilesReviewStatsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesReviewStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGigsterProfilesReviewStatsRetrieveQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGigsterProfilesStripeAccountAddRequirementCreateUrl = (id: number | 'me',) => {




  return `/api/gigster-profiles/${id}/stripe-account-add-requirement/`
}

/**
 * Enables IDV on stripe for the given account
 *
 * https://stripe.com/docs/api/accounts/update
 */
export const gigsterProfilesStripeAccountAddRequirementCreate = async (id: number | 'me',
    addRequirementToAccountRequest: AddRequirementToAccountRequest, options?: Parameters<typeof customFetch>[1]): Promise<AddRequirementToAccount> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<AddRequirementToAccount>(getGigsterProfilesStripeAccountAddRequirementCreateUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(addRequirementToAccountRequest)
  }
);}





export const getGigsterProfilesStripeAccountAddRequirementCreateMutationKey = () => ['gigsterProfilesStripeAccountAddRequirementCreate'] as const;

export const getGigsterProfilesStripeAccountAddRequirementCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof gigsterProfilesStripeAccountAddRequirementCreate>>, TError,GigsterProfilesStripeAccountAddRequirementCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof gigsterProfilesStripeAccountAddRequirementCreate>>, TError,GigsterProfilesStripeAccountAddRequirementCreateMutationVariables, TContext> => {

const mutationKey = getGigsterProfilesStripeAccountAddRequirementCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof gigsterProfilesStripeAccountAddRequirementCreate>>, GigsterProfilesStripeAccountAddRequirementCreateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  gigsterProfilesStripeAccountAddRequirementCreate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GigsterProfilesStripeAccountAddRequirementCreateMutationResult = NonNullable<Awaited<ReturnType<typeof gigsterProfilesStripeAccountAddRequirementCreate>>>
    export type GigsterProfilesStripeAccountAddRequirementCreateMutationBody = AddRequirementToAccountRequest
    export type GigsterProfilesStripeAccountAddRequirementCreateMutationError = void
    export type GigsterProfilesStripeAccountAddRequirementCreateMutationVariables = {id: number | 'me';data: AddRequirementToAccountRequest}

    export const useGigsterProfilesStripeAccountAddRequirementCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof gigsterProfilesStripeAccountAddRequirementCreate>>, TError,GigsterProfilesStripeAccountAddRequirementCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof gigsterProfilesStripeAccountAddRequirementCreate>>,
        TError,
        GigsterProfilesStripeAccountAddRequirementCreateMutationVariables,
        TContext
      > => {
      return useMutation(getGigsterProfilesStripeAccountAddRequirementCreateMutationOptions(options), queryClient);
    }
    export const getGigsterProfilesStripeAccountLinkRetrieveUrl = (id: number | 'me',
    params?: GigsterProfilesStripeAccountLinkRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/gigster-profiles/${id}/stripe-account-link/?${stringifiedParams}` : `/api/gigster-profiles/${id}/stripe-account-link/`
}

/**
 * Retrieves a new Stripe account link, allowing the user to complete their Stripe onboarding
 *
 * Note that if the current user does not yet have a Stripe profile we will create one
 * on the fly and return the account link.
 * However, if the pro already has a Stripe account on file then we will use their existing account.
 */
export const gigsterProfilesStripeAccountLinkRetrieve = async (id: number | 'me',
    params?: GigsterProfilesStripeAccountLinkRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<StripeAccountLink> => {

  return customFetch<StripeAccountLink>(getGigsterProfilesStripeAccountLinkRetrieveUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGigsterProfilesStripeAccountLinkRetrieveQueryKey = (id: number | 'me',
    params?: GigsterProfilesStripeAccountLinkRetrieveParams,) => {
    return [
    `/api/gigster-profiles/${id}/stripe-account-link/`, ...(params ? [params] : [])
    ] as const;
    }


export const getGigsterProfilesStripeAccountLinkRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof gigsterProfilesStripeAccountLinkRetrieve>>, TError = void>(id: number | 'me',
    params?: GigsterProfilesStripeAccountLinkRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesStripeAccountLinkRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGigsterProfilesStripeAccountLinkRetrieveQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof gigsterProfilesStripeAccountLinkRetrieve>>> = ({ signal }) => gigsterProfilesStripeAccountLinkRetrieve(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesStripeAccountLinkRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GigsterProfilesStripeAccountLinkRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof gigsterProfilesStripeAccountLinkRetrieve>>>
export type GigsterProfilesStripeAccountLinkRetrieveQueryError = void


export function useGigsterProfilesStripeAccountLinkRetrieve<TData = Awaited<ReturnType<typeof gigsterProfilesStripeAccountLinkRetrieve>>, TError = void>(
 id: number | 'me',
    params: undefined |  GigsterProfilesStripeAccountLinkRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesStripeAccountLinkRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsterProfilesStripeAccountLinkRetrieve>>,
          TError,
          Awaited<ReturnType<typeof gigsterProfilesStripeAccountLinkRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsterProfilesStripeAccountLinkRetrieve<TData = Awaited<ReturnType<typeof gigsterProfilesStripeAccountLinkRetrieve>>, TError = void>(
 id: number | 'me',
    params?: GigsterProfilesStripeAccountLinkRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesStripeAccountLinkRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsterProfilesStripeAccountLinkRetrieve>>,
          TError,
          Awaited<ReturnType<typeof gigsterProfilesStripeAccountLinkRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsterProfilesStripeAccountLinkRetrieve<TData = Awaited<ReturnType<typeof gigsterProfilesStripeAccountLinkRetrieve>>, TError = void>(
 id: number | 'me',
    params?: GigsterProfilesStripeAccountLinkRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesStripeAccountLinkRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGigsterProfilesStripeAccountLinkRetrieve<TData = Awaited<ReturnType<typeof gigsterProfilesStripeAccountLinkRetrieve>>, TError = void>(
 id: number | 'me',
    params?: GigsterProfilesStripeAccountLinkRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesStripeAccountLinkRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGigsterProfilesStripeAccountLinkRetrieveQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGigsterProfilesStripeAccountStatusRetrieveUrl = (id: number | 'me',
    params?: GigsterProfilesStripeAccountStatusRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/gigster-profiles/${id}/stripe-account-status/?${stringifiedParams}` : `/api/gigster-profiles/${id}/stripe-account-status/`
}

/**
 * Retrieves the status of the pro's Stripe account.
 *
 * This api is largely a wrapper around stripe.Account.retrieve() but returns only a subset of important fields
 * for performance and security reasons.
 *
 * https://stripe.com/docs/api/accounts/retrieve
 */
export const gigsterProfilesStripeAccountStatusRetrieve = async (id: number | 'me',
    params?: GigsterProfilesStripeAccountStatusRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<StripeAccountStatus> => {

  return customFetch<StripeAccountStatus>(getGigsterProfilesStripeAccountStatusRetrieveUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGigsterProfilesStripeAccountStatusRetrieveQueryKey = (id: number | 'me',
    params?: GigsterProfilesStripeAccountStatusRetrieveParams,) => {
    return [
    `/api/gigster-profiles/${id}/stripe-account-status/`, ...(params ? [params] : [])
    ] as const;
    }


export const getGigsterProfilesStripeAccountStatusRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof gigsterProfilesStripeAccountStatusRetrieve>>, TError = void>(id: number | 'me',
    params?: GigsterProfilesStripeAccountStatusRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesStripeAccountStatusRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGigsterProfilesStripeAccountStatusRetrieveQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof gigsterProfilesStripeAccountStatusRetrieve>>> = ({ signal }) => gigsterProfilesStripeAccountStatusRetrieve(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesStripeAccountStatusRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GigsterProfilesStripeAccountStatusRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof gigsterProfilesStripeAccountStatusRetrieve>>>
export type GigsterProfilesStripeAccountStatusRetrieveQueryError = void


export function useGigsterProfilesStripeAccountStatusRetrieve<TData = Awaited<ReturnType<typeof gigsterProfilesStripeAccountStatusRetrieve>>, TError = void>(
 id: number | 'me',
    params: undefined |  GigsterProfilesStripeAccountStatusRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesStripeAccountStatusRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsterProfilesStripeAccountStatusRetrieve>>,
          TError,
          Awaited<ReturnType<typeof gigsterProfilesStripeAccountStatusRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsterProfilesStripeAccountStatusRetrieve<TData = Awaited<ReturnType<typeof gigsterProfilesStripeAccountStatusRetrieve>>, TError = void>(
 id: number | 'me',
    params?: GigsterProfilesStripeAccountStatusRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesStripeAccountStatusRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsterProfilesStripeAccountStatusRetrieve>>,
          TError,
          Awaited<ReturnType<typeof gigsterProfilesStripeAccountStatusRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsterProfilesStripeAccountStatusRetrieve<TData = Awaited<ReturnType<typeof gigsterProfilesStripeAccountStatusRetrieve>>, TError = void>(
 id: number | 'me',
    params?: GigsterProfilesStripeAccountStatusRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesStripeAccountStatusRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGigsterProfilesStripeAccountStatusRetrieve<TData = Awaited<ReturnType<typeof gigsterProfilesStripeAccountStatusRetrieve>>, TError = void>(
 id: number | 'me',
    params?: GigsterProfilesStripeAccountStatusRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesStripeAccountStatusRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGigsterProfilesStripeAccountStatusRetrieveQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGigsterProfilesStripeLoginLinkRetrieveUrl = (id: number | 'me',) => {




  return `/api/gigster-profiles/${id}/stripe-login-link/`
}

/**
 * Retrieves a new Stripe login link, allowing the user to access their dashboard
 */
export const gigsterProfilesStripeLoginLinkRetrieve = async (id: number | 'me', options?: Parameters<typeof customFetch>[1]): Promise<StripeLoginLink> => {

  return customFetch<StripeLoginLink>(getGigsterProfilesStripeLoginLinkRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGigsterProfilesStripeLoginLinkRetrieveQueryKey = (id: number | 'me',) => {
    return [
    `/api/gigster-profiles/${id}/stripe-login-link/`
    ] as const;
    }


export const getGigsterProfilesStripeLoginLinkRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof gigsterProfilesStripeLoginLinkRetrieve>>, TError = void>(id: number | 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesStripeLoginLinkRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGigsterProfilesStripeLoginLinkRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof gigsterProfilesStripeLoginLinkRetrieve>>> = ({ signal }) => gigsterProfilesStripeLoginLinkRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesStripeLoginLinkRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GigsterProfilesStripeLoginLinkRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof gigsterProfilesStripeLoginLinkRetrieve>>>
export type GigsterProfilesStripeLoginLinkRetrieveQueryError = void


export function useGigsterProfilesStripeLoginLinkRetrieve<TData = Awaited<ReturnType<typeof gigsterProfilesStripeLoginLinkRetrieve>>, TError = void>(
 id: number | 'me', options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesStripeLoginLinkRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsterProfilesStripeLoginLinkRetrieve>>,
          TError,
          Awaited<ReturnType<typeof gigsterProfilesStripeLoginLinkRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsterProfilesStripeLoginLinkRetrieve<TData = Awaited<ReturnType<typeof gigsterProfilesStripeLoginLinkRetrieve>>, TError = void>(
 id: number | 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesStripeLoginLinkRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsterProfilesStripeLoginLinkRetrieve>>,
          TError,
          Awaited<ReturnType<typeof gigsterProfilesStripeLoginLinkRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsterProfilesStripeLoginLinkRetrieve<TData = Awaited<ReturnType<typeof gigsterProfilesStripeLoginLinkRetrieve>>, TError = void>(
 id: number | 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesStripeLoginLinkRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGigsterProfilesStripeLoginLinkRetrieve<TData = Awaited<ReturnType<typeof gigsterProfilesStripeLoginLinkRetrieve>>, TError = void>(
 id: number | 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesStripeLoginLinkRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGigsterProfilesStripeLoginLinkRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGigsterProfilesUnfavoriteAllDestroyUrl = (id: number,) => {




  return `/api/gigster-profiles/${id}/unfavorite-all/`
}

export const gigsterProfilesUnfavoriteAllDestroy = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getGigsterProfilesUnfavoriteAllDestroyUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getGigsterProfilesUnfavoriteAllDestroyMutationKey = () => ['gigsterProfilesUnfavoriteAllDestroy'] as const;

export const getGigsterProfilesUnfavoriteAllDestroyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof gigsterProfilesUnfavoriteAllDestroy>>, TError,GigsterProfilesUnfavoriteAllDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof gigsterProfilesUnfavoriteAllDestroy>>, TError,GigsterProfilesUnfavoriteAllDestroyMutationVariables, TContext> => {

const mutationKey = getGigsterProfilesUnfavoriteAllDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof gigsterProfilesUnfavoriteAllDestroy>>, GigsterProfilesUnfavoriteAllDestroyMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  gigsterProfilesUnfavoriteAllDestroy(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GigsterProfilesUnfavoriteAllDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof gigsterProfilesUnfavoriteAllDestroy>>>

    export type GigsterProfilesUnfavoriteAllDestroyMutationError = void
    export type GigsterProfilesUnfavoriteAllDestroyMutationVariables = {id: number}

    export const useGigsterProfilesUnfavoriteAllDestroy = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof gigsterProfilesUnfavoriteAllDestroy>>, TError,GigsterProfilesUnfavoriteAllDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof gigsterProfilesUnfavoriteAllDestroy>>,
        TError,
        GigsterProfilesUnfavoriteAllDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getGigsterProfilesUnfavoriteAllDestroyMutationOptions(options), queryClient);
    }
    export const getGigsterProfilesW2DashboardLinkRetrieveUrl = (id: number | 'me',) => {




  return `/api/gigster-profiles/${id}/w2-dashboard-link/`
}

export const gigsterProfilesW2DashboardLinkRetrieve = async (id: number | 'me', options?: Parameters<typeof customFetch>[1]): Promise<string> => {

  return customFetch<string>(getGigsterProfilesW2DashboardLinkRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGigsterProfilesW2DashboardLinkRetrieveQueryKey = (id: number | 'me',) => {
    return [
    `/api/gigster-profiles/${id}/w2-dashboard-link/`
    ] as const;
    }


export const getGigsterProfilesW2DashboardLinkRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof gigsterProfilesW2DashboardLinkRetrieve>>, TError = void>(id: number | 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesW2DashboardLinkRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGigsterProfilesW2DashboardLinkRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof gigsterProfilesW2DashboardLinkRetrieve>>> = ({ signal }) => gigsterProfilesW2DashboardLinkRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesW2DashboardLinkRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GigsterProfilesW2DashboardLinkRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof gigsterProfilesW2DashboardLinkRetrieve>>>
export type GigsterProfilesW2DashboardLinkRetrieveQueryError = void


export function useGigsterProfilesW2DashboardLinkRetrieve<TData = Awaited<ReturnType<typeof gigsterProfilesW2DashboardLinkRetrieve>>, TError = void>(
 id: number | 'me', options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesW2DashboardLinkRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsterProfilesW2DashboardLinkRetrieve>>,
          TError,
          Awaited<ReturnType<typeof gigsterProfilesW2DashboardLinkRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsterProfilesW2DashboardLinkRetrieve<TData = Awaited<ReturnType<typeof gigsterProfilesW2DashboardLinkRetrieve>>, TError = void>(
 id: number | 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesW2DashboardLinkRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsterProfilesW2DashboardLinkRetrieve>>,
          TError,
          Awaited<ReturnType<typeof gigsterProfilesW2DashboardLinkRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsterProfilesW2DashboardLinkRetrieve<TData = Awaited<ReturnType<typeof gigsterProfilesW2DashboardLinkRetrieve>>, TError = void>(
 id: number | 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesW2DashboardLinkRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGigsterProfilesW2DashboardLinkRetrieve<TData = Awaited<ReturnType<typeof gigsterProfilesW2DashboardLinkRetrieve>>, TError = void>(
 id: number | 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesW2DashboardLinkRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGigsterProfilesW2DashboardLinkRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGigsterProfilesW2EarningsStatsRetrieveUrl = (id: number | 'me',) => {




  return `/api/gigster-profiles/${id}/w2-earnings-stats/`
}

export const gigsterProfilesW2EarningsStatsRetrieve = async (id: number | 'me', options?: Parameters<typeof customFetch>[1]): Promise<EmployeeEarningsStats> => {

  return customFetch<EmployeeEarningsStats>(getGigsterProfilesW2EarningsStatsRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGigsterProfilesW2EarningsStatsRetrieveQueryKey = (id: number | 'me',) => {
    return [
    `/api/gigster-profiles/${id}/w2-earnings-stats/`
    ] as const;
    }


export const getGigsterProfilesW2EarningsStatsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof gigsterProfilesW2EarningsStatsRetrieve>>, TError = void>(id: number | 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesW2EarningsStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGigsterProfilesW2EarningsStatsRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof gigsterProfilesW2EarningsStatsRetrieve>>> = ({ signal }) => gigsterProfilesW2EarningsStatsRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesW2EarningsStatsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GigsterProfilesW2EarningsStatsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof gigsterProfilesW2EarningsStatsRetrieve>>>
export type GigsterProfilesW2EarningsStatsRetrieveQueryError = void


export function useGigsterProfilesW2EarningsStatsRetrieve<TData = Awaited<ReturnType<typeof gigsterProfilesW2EarningsStatsRetrieve>>, TError = void>(
 id: number | 'me', options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesW2EarningsStatsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsterProfilesW2EarningsStatsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof gigsterProfilesW2EarningsStatsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsterProfilesW2EarningsStatsRetrieve<TData = Awaited<ReturnType<typeof gigsterProfilesW2EarningsStatsRetrieve>>, TError = void>(
 id: number | 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesW2EarningsStatsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsterProfilesW2EarningsStatsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof gigsterProfilesW2EarningsStatsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsterProfilesW2EarningsStatsRetrieve<TData = Awaited<ReturnType<typeof gigsterProfilesW2EarningsStatsRetrieve>>, TError = void>(
 id: number | 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesW2EarningsStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGigsterProfilesW2EarningsStatsRetrieve<TData = Awaited<ReturnType<typeof gigsterProfilesW2EarningsStatsRetrieve>>, TError = void>(
 id: number | 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesW2EarningsStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGigsterProfilesW2EarningsStatsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGigsterProfilesW2EmployeeRetrieveUrl = (id: number | 'me',) => {




  return `/api/gigster-profiles/${id}/w2-employee/`
}

export const gigsterProfilesW2EmployeeRetrieve = async (id: number | 'me', options?: Parameters<typeof customFetch>[1]): Promise<Employee> => {

  return customFetch<Employee>(getGigsterProfilesW2EmployeeRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGigsterProfilesW2EmployeeRetrieveQueryKey = (id: number | 'me',) => {
    return [
    `/api/gigster-profiles/${id}/w2-employee/`
    ] as const;
    }


export const getGigsterProfilesW2EmployeeRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof gigsterProfilesW2EmployeeRetrieve>>, TError = void>(id: number | 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesW2EmployeeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGigsterProfilesW2EmployeeRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof gigsterProfilesW2EmployeeRetrieve>>> = ({ signal }) => gigsterProfilesW2EmployeeRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesW2EmployeeRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GigsterProfilesW2EmployeeRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof gigsterProfilesW2EmployeeRetrieve>>>
export type GigsterProfilesW2EmployeeRetrieveQueryError = void


export function useGigsterProfilesW2EmployeeRetrieve<TData = Awaited<ReturnType<typeof gigsterProfilesW2EmployeeRetrieve>>, TError = void>(
 id: number | 'me', options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesW2EmployeeRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsterProfilesW2EmployeeRetrieve>>,
          TError,
          Awaited<ReturnType<typeof gigsterProfilesW2EmployeeRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsterProfilesW2EmployeeRetrieve<TData = Awaited<ReturnType<typeof gigsterProfilesW2EmployeeRetrieve>>, TError = void>(
 id: number | 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesW2EmployeeRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsterProfilesW2EmployeeRetrieve>>,
          TError,
          Awaited<ReturnType<typeof gigsterProfilesW2EmployeeRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsterProfilesW2EmployeeRetrieve<TData = Awaited<ReturnType<typeof gigsterProfilesW2EmployeeRetrieve>>, TError = void>(
 id: number | 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesW2EmployeeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGigsterProfilesW2EmployeeRetrieve<TData = Awaited<ReturnType<typeof gigsterProfilesW2EmployeeRetrieve>>, TError = void>(
 id: number | 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesW2EmployeeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGigsterProfilesW2EmployeeRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGigsterProfilesW2OnboardingLinkRetrieveUrl = (id: number | 'me',) => {




  return `/api/gigster-profiles/${id}/w2-onboarding-link/`
}

export const gigsterProfilesW2OnboardingLinkRetrieve = async (id: number | 'me', options?: Parameters<typeof customFetch>[1]): Promise<string> => {

  return customFetch<string>(getGigsterProfilesW2OnboardingLinkRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGigsterProfilesW2OnboardingLinkRetrieveQueryKey = (id: number | 'me',) => {
    return [
    `/api/gigster-profiles/${id}/w2-onboarding-link/`
    ] as const;
    }


export const getGigsterProfilesW2OnboardingLinkRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof gigsterProfilesW2OnboardingLinkRetrieve>>, TError = void | ServiceUnavailableError>(id: number | 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesW2OnboardingLinkRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGigsterProfilesW2OnboardingLinkRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof gigsterProfilesW2OnboardingLinkRetrieve>>> = ({ signal }) => gigsterProfilesW2OnboardingLinkRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesW2OnboardingLinkRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GigsterProfilesW2OnboardingLinkRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof gigsterProfilesW2OnboardingLinkRetrieve>>>
export type GigsterProfilesW2OnboardingLinkRetrieveQueryError = void | ServiceUnavailableError


export function useGigsterProfilesW2OnboardingLinkRetrieve<TData = Awaited<ReturnType<typeof gigsterProfilesW2OnboardingLinkRetrieve>>, TError = void | ServiceUnavailableError>(
 id: number | 'me', options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesW2OnboardingLinkRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsterProfilesW2OnboardingLinkRetrieve>>,
          TError,
          Awaited<ReturnType<typeof gigsterProfilesW2OnboardingLinkRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsterProfilesW2OnboardingLinkRetrieve<TData = Awaited<ReturnType<typeof gigsterProfilesW2OnboardingLinkRetrieve>>, TError = void | ServiceUnavailableError>(
 id: number | 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesW2OnboardingLinkRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsterProfilesW2OnboardingLinkRetrieve>>,
          TError,
          Awaited<ReturnType<typeof gigsterProfilesW2OnboardingLinkRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsterProfilesW2OnboardingLinkRetrieve<TData = Awaited<ReturnType<typeof gigsterProfilesW2OnboardingLinkRetrieve>>, TError = void | ServiceUnavailableError>(
 id: number | 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesW2OnboardingLinkRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGigsterProfilesW2OnboardingLinkRetrieve<TData = Awaited<ReturnType<typeof gigsterProfilesW2OnboardingLinkRetrieve>>, TError = void | ServiceUnavailableError>(
 id: number | 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesW2OnboardingLinkRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGigsterProfilesW2OnboardingLinkRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGigsterProfilesWorkHistoryListUrl = (id: number | 'me',
    params?: GigsterProfilesWorkHistoryListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/gigster-profiles/${id}/work-history/?${stringifiedParams}` : `/api/gigster-profiles/${id}/work-history/`
}

/**
 * @deprecated
 */
export const gigsterProfilesWorkHistoryList = async (id: number | 'me',
    params?: GigsterProfilesWorkHistoryListParams, options?: Parameters<typeof customFetch>[1]): Promise<WorkHistoryRecord[]> => {

  return customFetch<WorkHistoryRecord[]>(getGigsterProfilesWorkHistoryListUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGigsterProfilesWorkHistoryListQueryKey = (id: number | 'me',
    params?: GigsterProfilesWorkHistoryListParams,) => {
    return [
    `/api/gigster-profiles/${id}/work-history/`, ...(params ? [params] : [])
    ] as const;
    }


export const getGigsterProfilesWorkHistoryListQueryOptions = <TData = Awaited<ReturnType<typeof gigsterProfilesWorkHistoryList>>, TError = void>(id: number | 'me',
    params?: GigsterProfilesWorkHistoryListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesWorkHistoryList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGigsterProfilesWorkHistoryListQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof gigsterProfilesWorkHistoryList>>> = ({ signal }) => gigsterProfilesWorkHistoryList(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesWorkHistoryList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GigsterProfilesWorkHistoryListQueryResult = NonNullable<Awaited<ReturnType<typeof gigsterProfilesWorkHistoryList>>>
export type GigsterProfilesWorkHistoryListQueryError = void


export function useGigsterProfilesWorkHistoryList<TData = Awaited<ReturnType<typeof gigsterProfilesWorkHistoryList>>, TError = void>(
 id: number | 'me',
    params: undefined |  GigsterProfilesWorkHistoryListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesWorkHistoryList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsterProfilesWorkHistoryList>>,
          TError,
          Awaited<ReturnType<typeof gigsterProfilesWorkHistoryList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsterProfilesWorkHistoryList<TData = Awaited<ReturnType<typeof gigsterProfilesWorkHistoryList>>, TError = void>(
 id: number | 'me',
    params?: GigsterProfilesWorkHistoryListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesWorkHistoryList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsterProfilesWorkHistoryList>>,
          TError,
          Awaited<ReturnType<typeof gigsterProfilesWorkHistoryList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsterProfilesWorkHistoryList<TData = Awaited<ReturnType<typeof gigsterProfilesWorkHistoryList>>, TError = void>(
 id: number | 'me',
    params?: GigsterProfilesWorkHistoryListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesWorkHistoryList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 */

export function useGigsterProfilesWorkHistoryList<TData = Awaited<ReturnType<typeof gigsterProfilesWorkHistoryList>>, TError = void>(
 id: number | 'me',
    params?: GigsterProfilesWorkHistoryListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesWorkHistoryList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGigsterProfilesWorkHistoryListQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGigsterProfilesCertificationRequestsListUrl = (params?: GigsterProfilesCertificationRequestsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/gigster-profiles/certification-requests/?${stringifiedParams}` : `/api/gigster-profiles/certification-requests/`
}

/**
 * Certification requests submitted by pros to get certified in specific
 * skills.
 *
 * Pros can create, update, and delete requests; admins review and approve or
 * reject them.
 */
export const gigsterProfilesCertificationRequestsList = async (params?: GigsterProfilesCertificationRequestsListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedBaseCertificationRequestList> => {

  return customFetch<PaginatedBaseCertificationRequestList>(getGigsterProfilesCertificationRequestsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGigsterProfilesCertificationRequestsListInfiniteQueryKey = (params?: GigsterProfilesCertificationRequestsListParams,) => {
    return [
    'infinite', `/api/gigster-profiles/certification-requests/`, ...(params ? [params] : [])
    ] as const;
    }

export const getGigsterProfilesCertificationRequestsListQueryKey = (params?: GigsterProfilesCertificationRequestsListParams,) => {
    return [
    `/api/gigster-profiles/certification-requests/`, ...(params ? [params] : [])
    ] as const;
    }


export const getGigsterProfilesCertificationRequestsListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsList>>, GigsterProfilesCertificationRequestsListParams['page']>, TError = void>(params?: GigsterProfilesCertificationRequestsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsList>>, TError, TData, QueryKey, GigsterProfilesCertificationRequestsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGigsterProfilesCertificationRequestsListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsList>>, QueryKey, GigsterProfilesCertificationRequestsListParams['page']> = ({ signal, pageParam }) => gigsterProfilesCertificationRequestsList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsList>>, TError, TData, QueryKey, GigsterProfilesCertificationRequestsListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GigsterProfilesCertificationRequestsListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsList>>>
export type GigsterProfilesCertificationRequestsListInfiniteQueryError = void


export function useGigsterProfilesCertificationRequestsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsList>>, GigsterProfilesCertificationRequestsListParams['page']>, TError = void>(
 params: undefined |  GigsterProfilesCertificationRequestsListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsList>>, TError, TData, QueryKey, GigsterProfilesCertificationRequestsListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsList>>,
          TError,
          Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsterProfilesCertificationRequestsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsList>>, GigsterProfilesCertificationRequestsListParams['page']>, TError = void>(
 params?: GigsterProfilesCertificationRequestsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsList>>, TError, TData, QueryKey, GigsterProfilesCertificationRequestsListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsList>>,
          TError,
          Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsterProfilesCertificationRequestsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsList>>, GigsterProfilesCertificationRequestsListParams['page']>, TError = void>(
 params?: GigsterProfilesCertificationRequestsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsList>>, TError, TData, QueryKey, GigsterProfilesCertificationRequestsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGigsterProfilesCertificationRequestsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsList>>, GigsterProfilesCertificationRequestsListParams['page']>, TError = void>(
 params?: GigsterProfilesCertificationRequestsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsList>>, TError, TData, QueryKey, GigsterProfilesCertificationRequestsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGigsterProfilesCertificationRequestsListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGigsterProfilesCertificationRequestsListQueryOptions = <TData = Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsList>>, TError = void>(params?: GigsterProfilesCertificationRequestsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGigsterProfilesCertificationRequestsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsList>>> = ({ signal }) => gigsterProfilesCertificationRequestsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GigsterProfilesCertificationRequestsListQueryResult = NonNullable<Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsList>>>
export type GigsterProfilesCertificationRequestsListQueryError = void


export function useGigsterProfilesCertificationRequestsList<TData = Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsList>>, TError = void>(
 params: undefined |  GigsterProfilesCertificationRequestsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsList>>,
          TError,
          Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsterProfilesCertificationRequestsList<TData = Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsList>>, TError = void>(
 params?: GigsterProfilesCertificationRequestsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsList>>,
          TError,
          Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsterProfilesCertificationRequestsList<TData = Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsList>>, TError = void>(
 params?: GigsterProfilesCertificationRequestsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGigsterProfilesCertificationRequestsList<TData = Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsList>>, TError = void>(
 params?: GigsterProfilesCertificationRequestsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGigsterProfilesCertificationRequestsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGigsterProfilesCertificationRequestsCreateUrl = () => {




  return `/api/gigster-profiles/certification-requests/`
}

/**
 * Certification requests submitted by pros to get certified in specific
 * skills.
 *
 * Pros can create, update, and delete requests; admins review and approve or
 * reject them.
 */
export const gigsterProfilesCertificationRequestsCreate = async (baseCertificationRequestRequest: BaseCertificationRequestRequest, options?: Parameters<typeof customFetch>[1]): Promise<BaseCertificationRequest> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<BaseCertificationRequest>(getGigsterProfilesCertificationRequestsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(baseCertificationRequestRequest)
  }
);}





export const getGigsterProfilesCertificationRequestsCreateMutationKey = () => ['gigsterProfilesCertificationRequestsCreate'] as const;

export const getGigsterProfilesCertificationRequestsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsCreate>>, TError,GigsterProfilesCertificationRequestsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsCreate>>, TError,GigsterProfilesCertificationRequestsCreateMutationVariables, TContext> => {

const mutationKey = getGigsterProfilesCertificationRequestsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsCreate>>, GigsterProfilesCertificationRequestsCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  gigsterProfilesCertificationRequestsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GigsterProfilesCertificationRequestsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsCreate>>>
    export type GigsterProfilesCertificationRequestsCreateMutationBody = BaseCertificationRequestRequest
    export type GigsterProfilesCertificationRequestsCreateMutationError = void
    export type GigsterProfilesCertificationRequestsCreateMutationVariables = {data: BaseCertificationRequestRequest}

    export const useGigsterProfilesCertificationRequestsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsCreate>>, TError,GigsterProfilesCertificationRequestsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsCreate>>,
        TError,
        GigsterProfilesCertificationRequestsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getGigsterProfilesCertificationRequestsCreateMutationOptions(options), queryClient);
    }
    export const getGigsterProfilesCertificationRequestsRetrieveUrl = (id: string,) => {




  return `/api/gigster-profiles/certification-requests/${id}/`
}

/**
 * Certification requests submitted by pros to get certified in specific
 * skills.
 *
 * Pros can create, update, and delete requests; admins review and approve or
 * reject them.
 */
export const gigsterProfilesCertificationRequestsRetrieve = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<BaseCertificationRequest> => {

  return customFetch<BaseCertificationRequest>(getGigsterProfilesCertificationRequestsRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGigsterProfilesCertificationRequestsRetrieveQueryKey = (id: string,) => {
    return [
    `/api/gigster-profiles/certification-requests/${id}/`
    ] as const;
    }


export const getGigsterProfilesCertificationRequestsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsRetrieve>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGigsterProfilesCertificationRequestsRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsRetrieve>>> = ({ signal }) => gigsterProfilesCertificationRequestsRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GigsterProfilesCertificationRequestsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsRetrieve>>>
export type GigsterProfilesCertificationRequestsRetrieveQueryError = void


export function useGigsterProfilesCertificationRequestsRetrieve<TData = Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsRetrieve>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsterProfilesCertificationRequestsRetrieve<TData = Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsterProfilesCertificationRequestsRetrieve<TData = Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGigsterProfilesCertificationRequestsRetrieve<TData = Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGigsterProfilesCertificationRequestsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGigsterProfilesCertificationRequestsPartialUpdateUrl = (id: string,) => {




  return `/api/gigster-profiles/certification-requests/${id}/`
}

/**
 * Certification requests submitted by pros to get certified in specific
 * skills.
 *
 * Pros can create, update, and delete requests; admins review and approve or
 * reject them.
 */
export const gigsterProfilesCertificationRequestsPartialUpdate = async (id: string,
    patchedProCertificationRequestUpdateRequest?: PatchedProCertificationRequestUpdateRequest, options?: Parameters<typeof customFetch>[1]): Promise<BaseCertificationRequest> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<BaseCertificationRequest>(getGigsterProfilesCertificationRequestsPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedProCertificationRequestUpdateRequest)
  }
);}





export const getGigsterProfilesCertificationRequestsPartialUpdateMutationKey = () => ['gigsterProfilesCertificationRequestsPartialUpdate'] as const;

export const getGigsterProfilesCertificationRequestsPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsPartialUpdate>>, TError,GigsterProfilesCertificationRequestsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsPartialUpdate>>, TError,GigsterProfilesCertificationRequestsPartialUpdateMutationVariables, TContext> => {

const mutationKey = getGigsterProfilesCertificationRequestsPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsPartialUpdate>>, GigsterProfilesCertificationRequestsPartialUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  gigsterProfilesCertificationRequestsPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GigsterProfilesCertificationRequestsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsPartialUpdate>>>
    export type GigsterProfilesCertificationRequestsPartialUpdateMutationBody = PatchedProCertificationRequestUpdateRequest | undefined
    export type GigsterProfilesCertificationRequestsPartialUpdateMutationError = void
    export type GigsterProfilesCertificationRequestsPartialUpdateMutationVariables = {id: string;data?: PatchedProCertificationRequestUpdateRequest}

    export const useGigsterProfilesCertificationRequestsPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsPartialUpdate>>, TError,GigsterProfilesCertificationRequestsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsPartialUpdate>>,
        TError,
        GigsterProfilesCertificationRequestsPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getGigsterProfilesCertificationRequestsPartialUpdateMutationOptions(options), queryClient);
    }
    export const getGigsterProfilesCertificationRequestsDestroyUrl = (id: string,) => {




  return `/api/gigster-profiles/certification-requests/${id}/`
}

/**
 * Certification requests submitted by pros to get certified in specific
 * skills.
 *
 * Pros can create, update, and delete requests; admins review and approve or
 * reject them.
 */
export const gigsterProfilesCertificationRequestsDestroy = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getGigsterProfilesCertificationRequestsDestroyUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getGigsterProfilesCertificationRequestsDestroyMutationKey = () => ['gigsterProfilesCertificationRequestsDestroy'] as const;

export const getGigsterProfilesCertificationRequestsDestroyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsDestroy>>, TError,GigsterProfilesCertificationRequestsDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsDestroy>>, TError,GigsterProfilesCertificationRequestsDestroyMutationVariables, TContext> => {

const mutationKey = getGigsterProfilesCertificationRequestsDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsDestroy>>, GigsterProfilesCertificationRequestsDestroyMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  gigsterProfilesCertificationRequestsDestroy(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GigsterProfilesCertificationRequestsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsDestroy>>>

    export type GigsterProfilesCertificationRequestsDestroyMutationError = void
    export type GigsterProfilesCertificationRequestsDestroyMutationVariables = {id: string}

    export const useGigsterProfilesCertificationRequestsDestroy = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsDestroy>>, TError,GigsterProfilesCertificationRequestsDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof gigsterProfilesCertificationRequestsDestroy>>,
        TError,
        GigsterProfilesCertificationRequestsDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getGigsterProfilesCertificationRequestsDestroyMutationOptions(options), queryClient);
    }
